import { SupportedLanguage } from "interfaces";
import { z } from "zod";

export const languageSchema = (languages: SupportedLanguage[], optional = false) => {
  return z.object({
    en: (languages.includes(SupportedLanguage.EN) && !optional)
      ? z.string().min(1, "This field is required")
      : z.string().optional().nullable(),
    vi: (languages.includes(SupportedLanguage.VI) && !optional)
      ? z.string().min(1, "This field is required")
      : z.string().optional().nullable(),
  }); 
}
